.topNav-wrap {
  display: flex;
  width: 100%;

  .desktop & {
    display: grid;
    grid-template-columns: calc(50% - 295px) 500px 2fr 1fr;
    gap: 1rem;
    align-items: center;

    > :first-child {
      justify-self: end;
    }
  }

  > button {
    .desktop & {
      position: absolute;
      right: 16px;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  .ads {
    .desktop & {
      justify-self: center;
    }
  }
}
